var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"task-reference-activity",attrs:{"value":_vm.promise,"theme":"default"}},[(_vm.item)?_c('Activity',{attrs:{"item":_vm.item}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }